<template>
  <div>
    <a-modal v-model:visible="show" :bodyStyle="bodyStyle" :width="'1000px'" title="选择房间" @ok="handleOk">
      <a-tabs v-model:activeKey="activeKey" @change="handleChangeTabs">
        <a-tab-pane :key="1" tab="空房"></a-tab-pane>
        <a-tab-pane :key="2" tab="已占用"></a-tab-pane>
        <template #rightExtra>
          <a-input-search v-model:value="keyword" allowClear placeholder="房间名称" style="width: 200px" @clear="onClear" @search="onSearch" />
        </template>
      </a-tabs>
      <div class="house-list">
        <a-radio-group v-model:value="selHouseItem">
          <a-radio v-for="(item, index) in houseList" :key="index" :value="item">{{ item.name }} </a-radio>
        </a-radio-group>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { reactive, toRefs, watch } from 'vue';
import dayJs from 'dayjs';
import { getStockRoomList } from '@/api/api';
import { message } from 'ant-design-vue';

export default {
  name: 'select-room',
  props: {
    visible: {
      default: false,
    },
    startDate: {
      default: dayJs().format('YYYY-MM-DD'),
    },
    endDate: {
      default: dayJs().add(1, 'day').format('YYYY-MM-DD'),
    },
  },
  emits: ['update:visible', 'change'],
  setup(props, { emit }) {
    const modal = reactive({
      keyword: '',
      selHouseItem: '',
      show: false,
      activeKey: 1,
      bodyStyle: {
        padding: '0 24px',
      },
      houseList: [],
      initList: [],
      handleChangeTabs() {
        modal.getStockRoomList();
      },
      // 确认
      handleOk() {
        if (!modal.selHouseItem.id) {
          message.error('请选择房间');
          return;
        }
        emit('change', modal.selHouseItem);
        modal.show = false;
      },
      // 重置
      onClear() {
        // modal.houseList = modal.initList;
        modal.getStockRoomList();
      },
      // 搜索
      onSearch() {
        modal.selHouseItem = '';
        if (!modal.keyword) {
          modal.onClear();
        } else {
          // modal.houseList = modal.initList.filter((i) => {
          //   return i.name.includes(modal.keyword);
          // });
          modal.getStockRoomList();
        }
      },
      // 获取可定房间列表
      getStockRoomList() {
        getStockRoomList({
          start: 0,
          limit: 9999,
          keyword: modal.keyword,
          table: modal.activeKey == 1 ? 1 : 3,
          start_time: props.startDate,
          end_time: props.endDate,
        }).then(res => {
          modal.houseList = res.data;
          modal.initList = res.data;
        });
      },
    });
    watch(
      () => props.visible,
      n => {
        modal.show = n;
        if (n) {
          modal.selHouseItem = '';
          modal.getStockRoomList();
        }
      }
    );

    watch(
      () => modal.show,
      value => {
        emit('update:visible', value);
      }
    );
    return {
      ...toRefs(modal),
    };
  },
};
</script>
<style lang="scss" scoped>
.house-list {
  height: 500px;
  overflow-y: auto;

  :deep(.ant-radio-wrapper) {
    width: 220px;
    margin-bottom: 6px;
  }
}
</style>
